import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {AppComponent} from './app.component';
import {ContactOffComponent} from './page/contact-off.page/contact-off.component';
import {ContactProjectComponent} from './page/contact-project.page/contact-project.component';
import {ContactWorkersComponent} from './page/contact-workers.page/contact-workers.component';
import {DataContactPolicyComponent} from './page/data-protection-policy.page/data-contact-policy.component';
import {Error404Component} from './page/error-404.page/error-404.component';
import {AppRoutingModule} from './app.routing.module';
import {LegalNoticeComponent} from './page/legal-notice.page/legal-notice.component';
import {HeaderComponent} from './component/header.component/header.component';
import {IndexComponent} from './page/index.page/index.component';
import {FooterComponent} from './component/footer.component/footer.component';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {AppService} from './app.service';
import {CookieComponent} from './component/cookie.component/cookie.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormComponent} from './component/form.component/form.component';

/**
 * The about module
 */
@NgModule({
  declarations: [
    AppComponent,
    ContactOffComponent,
    ContactProjectComponent,
    ContactWorkersComponent,
    DataContactPolicyComponent,
    Error404Component,
    LegalNoticeComponent,
    IndexComponent,
    HeaderComponent,
    FooterComponent,
    CookieComponent,
    FormComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    AppService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
